<template>
  <div
    v-if="!isLoading2"
  >
    <div class="section">
      <filer-screens-nav />
      <div class="columns is-centered">
        <div class="column is-10">
          <div class="columns">
            <div class="column content">
              <h3 class="title is-3">
                Let's Get Started
              </h3>
              <ol>
                <li>We recommend having access to your tax forms and financial statements.</li>
                <li>Select a year below to start the filing and/or amendment process.</li>
                <li>The requirement to file the Commonwealth of PA Statement is based on job duties. The City and Mayor's Statements are filed by specifically identified City officials and employees.</li>
              </ol>
            </div>
          </div>
          <div
            v-if="!hasRequirements"
            class="columns"
          >
            <div class="column">
              <div class="message is-warning">
                <div class="message-body">
                  <b>Attention:</b> no form requirements (City, State or Mayor) have been assigned to this profile. You will not be able to start a new filing this issue is fixed. Please contact support.
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <Dropdown
                v-model="filingYear"
                class="is-half-length"
                :options="filingYearDD"
                placeholder="Select Filing Year"
                label="Selected year"
                value-key="value"
                text-key="label"
              />
              <div v-if="filingYear !== ''">
                <br>
                <div v-if="filingsByYear.length > 0">
                  <table class="file-now-table table is-bordered is-striped is-fullwidth table-content-center">
                    <thead>
                      <tr>
                        <th rowspan="2">
                          Year
                        </th>
                        <th :colspan="showMayorForm ? '3' : '2'">
                          Required Forms
                        </th>
                        <th rowspan="2">
                          Status
                        </th>
                        <th rowspan="2">
                          Type
                        </th>
                        <th rowspan="2">
                          Date
                        </th>
                        <th rowspan="2">
                          Action
                        </th>
                      </tr>
                      <tr>
                        <th>City<sup>*</sup></th>
                        <th>State<sup>*</sup></th>
                        <th v-if="showMayorForm">
                          Mayor<sup>*</sup>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="filing in filingsByYear"
                        :key="filing.id"
                      >
                        <td>{{ filing.year }}</td>
                        <td>
                          <template v-if="filing.cityForm === 'Y'">
                            <div v-if="filing.filingStatus === 'FI' || filing.filingStatus === 'AF'">
                              <div v-if="filing.cityUrl !== null">
                                <a
                                  class="button is-small is-secondary"
                                  :href="filing.cityUrl"
                                  target="_blank"
                                >
                                  <span>View PDF</span>
                                  <span class="icon">
                                    <i class="is-small fad fa-file-pdf" />
                                  </span>
                                </a>
                              </div>
                              <div v-else>
                                <template v-if="filing.cityPdfUrl">
                                  <a
                                    :href="filing.cityPdfUrl"
                                    class="button is-small is-secondary"
                                    target="_blank"
                                  >
                                    <span>View PDF</span>
                                    <span class="icon">
                                      <i class="is-small fad fa-file-pdf" />
                                    </span>
                                  </a>
                                </template>
                                <template v-else>
                                  <a
                                    :ref="`City_${filing.id}`"
                                    class="button is-small is-secondary"
                                    href="#"
                                    target="_blank"
                                    @click.prevent="genPdfUrl('City', filing.id)"
                                  >
                                    <span>View PDF</span>
                                    <span class="icon">
                                      <i class="is-small fad fa-file-pdf" />
                                    </span>
                                  </a>
                                </template>
                              </div>
                            </div>
                            <div v-else>
                              <div class="icon has-text-phanatic-green">
                                <i class="fad fa-check" />
                              </div>
                            </div>
                          </template>
                          <template v-else>
                            ---
                          </template>
                        </td>
                        <td>
                          <template v-if="filing.stateForm === 'Y'">
                            <div v-if="filing.filingStatus === 'FI' || filing.filingStatus === 'AF'">
                              <template v-if="filing.filedOffline !== 'Y'">
                                <template v-if="filing.statePdfUrl">
                                  <a
                                    class="button is-small is-secondary"
                                    :href="filing.statePdfUrl"
                                    target="_blank"
                                  >
                                    <span>View PDF</span>
                                    <span class="icon">
                                      <i class="is-small fad fa-file-pdf" />
                                    </span>
                                  </a>
                                </template>
                                <template v-else>
                                  <a
                                    :ref="`State_${filing.id}`"
                                    class="button is-small is-secondary"
                                    href="#"
                                    target="_blank"
                                    @click.prevent="genPdfUrl('State', filing.id)"
                                  >
                                    <span>View PDF</span>
                                    <span class="icon">
                                      <i class="is-small fad fa-file-pdf" />
                                    </span>
                                  </a>
                                </template>
                              </template>
                              <template v-else>
                                <template v-if="filing.stateUrl !== null">
                                  <a
                                    class="button is-small is-secondary"
                                    :href="filing.stateUrl"
                                    target="_blank"
                                  >
                                    <span>View PDF</span>
                                    <span class="icon">
                                      <i class="is-small fad fa-file-pdf" />
                                    </span>
                                  </a>
                                </template>
                                <template v-else>
                                  <button
                                    id="modal-no-paper-filing-btn"
                                    type="button"
                                    class="button is-small is-secondary"
                                    @click="noPaperFilingModal()"
                                  >
                                    <span>View PDF</span>
                                    <span class="icon is-small">
                                      <i class="is-small fad fa-file-pdf" />
                                    </span>
                                  </button>
                                </template>
                              </template>
                            </div>
                            <template v-else>
                              <div class="icon has-text-phanatic-green">
                                <i class="fad fa-check" />
                              </div>
                            </template>
                          </template>
                          <template v-else>
                            ---
                          </template>
                        </td>
                        <td v-if="showMayorForm">
                          <template v-if="filing.mayorForm === 'Y'">
                            <div v-if="filing.filingStatus === 'FI' || filing.filingStatus === 'AF'">
                              <template v-if="filing.filedOffline !== 'Y'">
                                <template v-if="filing.mayorPdfUrl">
                                  <a
                                    class="button is-small is-secondary"
                                    :href="filing.mayorPdfUrl"
                                    target="_blank"
                                  >
                                    <span>View PDF</span>
                                    <span class="icon">
                                      <i class="is-small fad fa-file-pdf" />
                                    </span>
                                  </a>
                                </template>
                                <template v-else>
                                  <a
                                    :ref="`Mayor_${filing.id}`"
                                    class="button is-small is-secondary"
                                    href="#"
                                    target="_blank"
                                    @click.prevent="genPdfUrl('Mayor', filing.id)"
                                  >
                                    <span>View PDF</span>
                                    <span class="icon">
                                      <i class="is-small fad fa-file-pdf" />
                                    </span>
                                  </a>
                                </template>
                              </template>
                              <template v-else>
                                <template v-if="filing.mayorUrl !== null">
                                  <a
                                    class="button is-small is-secondary"
                                    :href="filing.mayorUrl"
                                    target="_blank"
                                  >
                                    <span>View PDF</span>
                                    <span class="icon">
                                      <i class="is-small fad fa-file-pdf" />
                                    </span>
                                  </a>
                                </template>
                                <template v-else>
                                  <button
                                    id="modal-no-paper-filing-btn"
                                    type="button"
                                    class="button is-small is-secondary"
                                    @click="noPaperFilingModal()"
                                  >
                                    <span>View PDF</span>
                                    <span class="icon is-small">
                                      <i class="is-small fad fa-file-pdf" />
                                    </span>
                                  </button>
                                </template>
                              </template>
                            </div>
                            <template v-else>
                              <div class="icon has-text-phanatic-green">
                                <i class="fad fa-check" />
                              </div>
                            </template>
                          </template>
                          <template v-else>
                            ---
                          </template>
                        </td>
                        <td>
                          <template v-if="filing.filedOffline !== 'Y'">
                            {{ filingStatusLabel(filing.filingStatus) }}
                            <template v-if="filing.filingStatus !== 'AP' && filing.filingStatus !== 'NF'">
                              {{ filing.amendmentSeq | hasAmendmentSeq }}
                            </template>
                            <a
                              v-if="filing.filingStatus === 'NF' || filing.filingStatus === 'AP'"
                              @click="deleteDraftModal(filing.id)"
                            >
                              &nbsp; <span class="icon"><i
                                class="fa fa-trash has-text-danger"
                                aria-hidden="true"
                              /></span>
                            </a>
                          </template>
                          <template v-else>
                            <div v-if="filing.cityForm === 'Y'">
                              <template v-if="filing.filedOffline === 'Y' && filing.cityReceived === ''">
                                <strong>City:</strong> N/A
                              </template>
                              <template v-else>
                                <strong>City:</strong> {{ filing.cityReceived === 'Y' ? 'Received' : 'Pending' }}
                              </template>
                            </div>
                            <div v-if="filing.stateForm === 'Y'">
                              <template v-if="filing.filedOffline === 'Y' && filing.stateReceived === ''">
                                <strong>State:</strong> N/A
                              </template>
                              <template v-else>
                                <strong>State:</strong> {{ filing.stateReceived === 'Y' ? 'Received' : 'Pending' }}
                              </template>
                            </div>
                            <div v-if="filing.mayorForm === 'Y'">
                              <template v-if="filing.filedOffline === 'Y' && filing.mayorReceived === ''">
                                <strong>Mayor:</strong> N/A
                              </template>
                              <template v-else>
                                <strong>Mayor:</strong> {{ filing.mayorReceived === 'Y' ? 'Received' : 'Pending' }}
                              </template>
                            </div>
                          </template>
                        </td>
                        <td>
                          {{ filing.filedOffline === 'Y' ? 'Paper Filing' : 'Online Filing' }}
                        </td>
                        <td>
                          <template v-if="filing.filingStatus === 'NF' || filing.filingStatus === 'AP'">
                            Started on <br> {{ formatDate(filing.createdOn) }}
                          </template>
                          <template v-if="filing.filingStatus === 'FI'">
                            {{ filing.completedDate !== '0001-01-01T00:00:00' ? `Completed on ${formatDate(filing.completedDate)}` : 'Not available' }}
                          </template>
                          <template v-if="filing.filingStatus === 'AF'">
                            {{ filing.completedDate !== '0001-01-01T00:00:00' ? `Amended on ${formatDate(filing.completedDate)}` : 'Not available' }}
                          </template>
                        </td>
                        <td>
                          <template v-if="filing.amendable === 'Y'">
                            <template v-if="filing.filingStatus === 'AP'">
                              <button
                                id="continue-amend-btn"
                                type="button"
                                class="button is-primary is-small"
                                @click="continueFiling(filing.id)"
                              >
                                Continue Amendement
                              </button>
                            </template>
                            <template v-else>
                              <button
                                id="amend-btn"
                                type="button"
                                class="button is-primary is-small"
                                @click="initNewFiling('AP', filing.id)"
                              >
                                Amend
                              </button>
                            </template>
                          </template>
                          <template v-if="filing.amendable !== 'Y'">
                            <template v-if="filing.filingStatus === 'NF' || filing.filingStatus === 'AP'">
                              <button
                                id="continue-filing-btn"
                                type="button"
                                class="button is-primary is-small"
                                @click="continueFiling(filing.id)"
                              >
                                Continue Filing
                              </button>
                            </template>
                            <template v-else>
                              ---
                            </template>
                          </template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  v-if="filingsByYear.length === 0"
                >
                  <table class="file-now-table table is-bordered is-striped is-fullwidth table-content-center">
                    <thead>
                      <tr>
                        <th rowspan="2">
                          Year
                        </th>
                        <th :colspan="showMayorForm ? '3' : '2'">
                          Required Forms
                        </th>
                        <th rowspan="2">
                          Due Date
                        </th>
                        <th rowspan="2">
                          Action
                        </th>
                      </tr>
                      <tr>
                        <th>City<sup>*</sup></th>
                        <th>State<sup>*</sup></th>
                        <th v-if="showMayorForm">
                          Mayor<sup>*</sup>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{ filingYear }}</td>
                        <td>
                          <template v-if="userProfile.cityForm === 'Y'">
                            <div class="icon has-text-phanatic-green">
                              <i class="fad fa-check" />
                            </div>
                          </template>
                          <template v-else>
                            ---
                          </template>
                        </td>
                        <td>
                          <template v-if="userProfile.stateForm === 'Y'">
                            <div class="icon has-text-phanatic-green">
                              <i class="fad fa-check" />
                            </div>
                          </template>
                          <template v-else>
                            ---
                          </template>
                        </td>
                        <td v-if="showMayorForm">
                          <template v-if="userProfile.mayorForm === 'Y'">
                            <div class="icon has-text-phanatic-green">
                              <i class="fad fa-check" />
                            </div>
                          </template>
                          <template v-else>
                            ---
                          </template>
                        </td>
                        <td>
                          {{ filingsDueDate ? filingsDueDate.description : 'No due date set' }}
                        </td>
                        <td>
                          <button
                            v-if="!paperFiling"
                            id="file-now-btn"
                            type="button"
                            title="File Now"
                            class="button is-primary is-small"
                            :disabled="!hasRequirements"
                            @click="initNewFiling('NF')"
                          >
                            File Now
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <br>
                <p>
                  <small>*{{ formFullNames.city }} - {{ formNumbers.city }}<br>
                    *{{ formFullNames.state }} - {{ formNumbers.state }}<br>
                    *{{ formFullNames.mayor }} - {{ formNumbers.mayor }}</small>
                </p>
              </div>
            </div>
          </div>
          <hr>
          <div class="columns">
            <div class="column content">
              <div class="message is-info">
                <div class="message-body">
                  <h4>Do you have questions?</h4>
                  <p>
                    <strong>Contact the Board of Ethics at 215.686.9450</strong> for questions regarding the interpretation of a particular line of the form or for other legal advice.
                    <br>
                    <strong>Contact The Department of Records 215.686.2263</strong> for questions about the process of receiving and filing forms
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FilerScreensNav from '@/components/FilerScreensNav';
import { filerScreenHelpers } from '@/mixins/filerScreen';
import { pdfData } from '@/mixins/pdfData';
import DeleteDraft from '@/modals/DeleteDraft';
import CopyFilingFrom from '@/modals/CopyFilingFrom';
import IsCityEmployee from '@/modals/IsCityEmployee';
import { Dropdown } from '@phila/phila-ui';

export default {
  name: 'FileNow',
  components: {
    FilerScreensNav,
    Dropdown,
  },
  filters: {
    hasAmendmentSeq (amendmentSeq) {
      if (parseInt(amendmentSeq) > 0) {
        return amendmentSeq;
      }
      return '';
    },
  },
  mixins: [
    filerScreenHelpers,
    pdfData,
  ],
  props: {
    selectedYear: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      filingYear: '',
      paperFiling: false,
      copyFrom: null,
    };
  },
  computed: {
    filingYearDD () {
      const options = [];

      if (!this.allFilingYears.length > 0) {
        return options;
      }

      this.allFilingYears.forEach(year => {
        options.push({
          value: year.toString(),
          label: this.currentYear === year.toString() ? `${year} (Current Period)` : year,
        });
      });
      return options;
    },
    formFullNames () {
      return this.$store.state.formFullNames;
    },
    formNumbers () {
      return this.$store.state.formNumbers;
    },
    userProfile () {
      return this.$store.state.user.profile;
    },
    currentYear () {
      if (!this.$store.state.admin.controlValues.currentyear) {
        return '';
      }
      return this.$store.state.admin.controlValues.currentyear.slice(0, 1)[ 0 ].description;
    },
    filingYears () {
      return this.$store.getters[ 'admin/activeControlValues' ]('filingyears');
    },
    filingsDueDate () {
      if (this.filingYear !== '') {
        return this.$store.getters[ 'admin/filingsDueDate' ](this.filingYear);
      }
      return [];
    },
    filingsByYear () {
      if (this.filingYear !== '') {
        return this.$store.getters[ 'filings/filingsByYear' ](parseInt(this.filingYear));
      }
      return [];
    },
    hasRequirements () {
      if (this.userProfile) {
        if (this.userProfile.cityForm !== 'Y' && this.userProfile.stateForm !== 'Y' && this.userProfile.mayorForm !== 'Y') {
          return false;
        }
        return true;
      }
      return false;
    },

    /**
    * @desc merges user filing years with admin filing years range
    * @returns { Array } of years
    */
    allFilingYears () {
      let userFiledYears = this.cloneObj(this.$store.getters[ 'filings/userFiledYears' ]);

      if (this.filingYears && this.filingYears.length > 0) {
        this.filingYears.forEach(filingYear => {
          if (!userFiledYears.includes(parseInt(filingYear.description))) {
            userFiledYears.push(parseInt(filingYear.description));
          }
        });
      }
      return userFiledYears.sort((a, b) => b - a);
    },
  },
  async created () {
    await this.$sCache.clear('currentFilingId');
    await this.initialFetch();
    await this.initialAssign();
    this.$store.commit('loading', false);
    const userProfile = this.$store.state.user.profile;
    if (userProfile.isCityEmployee !== false && userProfile.isCityEmployee !== true) {
      this.isCityEmployeeModal();
    }
  },
  methods: {
    async genPdfUrl (type, filingId) {
      let el = this.$refs[`${type}_${filingId}`][0];
      el.text = 'loading...';
      let pdfData = await this.pdf_getPdfData(type, filingId);
      let pdfUrl = await this.$store.dispatch('filing/getPdf', pdfData);
      el.text = 'View PDF';
      window.open(pdfUrl, "_blank");
    },
    continueFiling (filingId) {
      this.$store.commit('filing/setCurrentFilingId', filingId);
      this.$sCache.set('currentFilingId', filingId);
      this.$router.push({ name: 'filer-information' });
    },
    async initialAssign () {
      if (this.selectedYear !== '') {
        this.filingYear = this.selectedYear.toString();
      } else {
        this.filingYear = this.currentYear.toString();
      }
    },
    async initialFetch () {
      let promises = [];
      promises.push(this.$store.dispatch('admin/getControlValue', 'currentyear'));
      promises.push(this.$store.dispatch('admin/getControlValue', 'filingyears'));
      promises.push(this.$store.dispatch('admin/getControlValue', 'filingduedate'));
      promises.push(this.$store.dispatch('filings/fetchUserFilings'));
      await Promise.all(promises);
    },
    getFilingIdFromPreviousYear (year) {
      let previousFilings = this.$store.getters[ 'filings/filingsByYear' ](year);

      if (previousFilings.length === 0) {
        return null;
      }

      //Can only copy from a filing that's FI or AF and that is not filed by paper.
      let filings = previousFilings.filter(filing => {
        if ((filing.filingStatus === 'FI' || filing.filingStatus === 'AF') && (filing.filedOffline !== 'Y')) {
          return true;
        }
        return false;
      });

      if (filings.length === 0) {
        return null;
      }

      //sort by ID to get the lastest filing of that year
      return filings.sort((a, b) => {
        return b.id - a.id;
      })[0].id;

    },
    async initNewFiling (filingStatus, filingId) {
      let year = this.filingYear;
      let showModal = false;

      //If this is a new filing let's set year to previous year and check if there's a previous filing we can copy from
      if (filingStatus === 'NF') {
        year = year - 1;
        this.copyFrom = this.getFilingIdFromPreviousYear(year);
      //If it's an amendment we need to copy from this filing instead
      } else if (filingStatus === 'AP') {
        this.copyFrom = filingId;
      }

      //If copy from is set, then we need to show the modal (as long as it's not an amendment)
      if (this.copyFrom === null || filingStatus === 'AP') {
        showModal = false;
      } else {
        showModal = true;
      }

      if (showModal) {
        this.$modal.show(
          CopyFilingFrom,
          {
            lastYear: year,
          },
          {
            name: 'copy-filing-modal',
            classes: [ 'is-small' ],
          },
          {
            'answer':  async (answer) => {
              if (!answer) {
                this.copyFrom = null;
              }
              if (await this.createNewFiling(filingStatus)) {
                this.$modal.hide('copy-filing-modal');
                this.$router.push({ name: 'filer-information' });
              }
            },
          },
        );
      } else {
        if (await this.createNewFiling(filingStatus)) {
          this.$router.push({ name: 'filer-information' });
        }
      }
    },
    async createNewFiling (filingStatus) {
      let filing = {
        year: this.filingYear,
        filingStatus,
      };

      if (this.copyFrom) {
        filing.copyFrom = this.copyFrom;
      }

      let newFilingRequest = await this.$store.dispatch('filing/createNewFiling', filing);
      return newFilingRequest;

    },
    filingStatusLabel (status) {
      return this.$store.state.filings.filingsMap[ status ];
    },
    deleteDraftModal (filingId) {
      this.$modal.show(DeleteDraft, {
        filingId,
        userType: 'self',
      }, {
        classes: [ 'is-small' ],
      });
    },
    isCityEmployeeModal () {
      this.$modal.show(IsCityEmployee, {}, {
        classes: [ 'is-small' ],
      });
    },
    updateFilingProfile (filingId, filingProfile) {
      this.$store.dispatch('filing/saveFiling', {
        filingId,
        filingProfile,
      });
    },
  },
};

</script>

<style scoped lang="scss">
  table.file-now-table {
    th, td {
      &:nth-child(1) {
        width: 5%;
      }
      &:nth-child(2), &:nth-child(3), &:nth-child(4) {
        width: 10%;
      }
      &:nth-child(5) {
        width: 15%;
      }
      &:nth-child(6) {
        width: 15%;
      }
      &:nth-child(7) {
        width: 15%;
      }
      &:nth-child(8) {
        width: 40%;
      }
    }
    &.table-content-center {
      td, th {
        text-align: center;
        vertical-align: middle;
      }
    }
    button {
      width: 100%;
      margin-bottom: 2px;
      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
  .is-half-length {
    width: 50%;
  }
</style>
